import { authAxios, publicAxios } from "../config";
import { ApiKey } from "../endpoints";

export const GetUpdateReqContent = async (reqData) => {
    try {
      const response = await authAxios.post(`${ApiKey.getAllReqContent}`,reqData);
      console.log(response);
      return response;
    } catch (error) {
      console.log("Error in package details", error);
    }
  };


export const ActionOnContentUpdateReq = async (data) => {
    try {
      const response = await authAxios.post(`${ApiKey.actionOnContentUpdateReq}`,data);
      console.log(response);
      return response;
    } catch (error) {
      console.log("Error in package details", error);
    }
  };
 